export default __webpack_public_path__ + "static/media/thank_you.c188386b.svg";